<template>
    <Vue-Good-Table
        :rows="rows"
        :columns="columns"
        :search-options="{
            enabled: true,
            skipDiacritics: true,
        }"
        style-class="vgt-table striped"
    >
        <template slot="table-row" slot-scope="props">
            <div v-if="props.column.field == 'links'" class="flex items-center">
                <Table-Links :row="props.row" />
            </div>
        </template>
    </Vue-Good-Table>
</template>

<script>
    import axios from 'axios';
    import { VueGoodTable } from 'vue-good-table';

    import TableLinks from './TableLinks';

    export default {
        name: 'ProductsTable',
        components: {
            VueGoodTable,
            TableLinks,
        },
        props: {
            customerId: {
                type: Number,
                default: null,
                required: false,
            },
        },
        data() {
            return {
                rows: [],
                columns: [
                    {
                        label: 'Ordernr.',
                        field: 'number',
                        sortable: true,
                    },
                    {
                        label: 'Klant',
                        field: 'customer',
                        sortable: false,
                    },
                    {
                        label: 'Totaal',
                        field: 'total_price',
                        sortable: false,
                    },
                    {
                        label: 'Acties',
                        field: 'links',
                    },
                ],
            };
        },
        created() {
            this.getRows();
        },
        methods: {
            getRows() {
                let route = this.route('api.orders.index');

                if (this.customerId) {
                    route = this.route('api.orders.index', { customerId: this.customerId });
                }

                axios.get(route)
                    .then(({ data }) => {
                        this.rows = data.data;
                    });
            },
        },
    };
</script>
